export default "__VITE_ASSET__JebOi5RT__"